import { useRef } from 'react';
import type React from 'react';

/**
 * Σκούρο φόντο παραθύρου που κλείνει με πάτημα: κλείνει ΜΟΝΟ όταν και το πάτημα ΞΕΚΙΝΗΣΕ στο
 * φόντο. Η οθόνη αφής στέλνει ένα click μετά το σήκωμα του δαχτύλου, με νέο έλεγχο του τι
 * βρίσκεται από κάτω· αν στο μεταξύ άνοιξε παράθυρο, το click πέφτει στο φόντο του και το έκλεινε
 * («τα Μετρητά δεν δουλεύουν με την οθόνη αφής», 15/10/2026). Ένα πάτημα που ξεκίνησε σε κουμπί
 * από κάτω, ή μέσα στο παράθυρο και τελείωσε έξω (σύρσιμο), δεν το κλείνει.
 */
export function useBackdropDismiss(onClose: () => void) {
  const pressStartedOnBackdrop = useRef(false);
  return {
    onPointerDown: (e: React.PointerEvent<HTMLElement>) => {
      pressStartedOnBackdrop.current = e.target === e.currentTarget;
    },
    onClick: (e: React.MouseEvent<HTMLElement>) => {
      const fromBackdrop = pressStartedOnBackdrop.current && e.target === e.currentTarget;
      pressStartedOnBackdrop.current = false;
      if (fromBackdrop) onClose();
    },
  };
}
